import pubsub from "@viewlift/pubsub";
var publishInitiateTvePopup = function (data) {
    pubsub.publish('initiate-tve-login-popup', data);
};
var subscribeInitiateTvePopup = function (cb) {
    pubsub.subscribe('initiate-tve-login-popup', cb);
};
export { publishInitiateTvePopup, subscribeInitiateTvePopup };
